import DeclinePage from "./DeclinePage";
export default DeclinePage;
